import React, {FunctionComponent, useEffect, useState} from "react";
import ViewWithSearchHeaderContainer from "@/Containers/ViewWithSearchHeaderContainer";
import LoadingElement from "@/Components/Loading/LoadingElement";
import {createRefetchContainer, RelayRefetchProp} from "react-relay";
import {FormProvider, useForm} from "react-hook-form";
import WarningConfirmDialog from "@/Components/ConfirmationModal/WarningConfirmDialog";
import {useDisplayMessage} from "@/Utils/CustomHooks/useDisplayMessage";
import {useConfirm} from "material-ui-confirm";
import {UserMainQueryRendererQueryResponse} from "@/Domains/UserManagement/User/QueryRenderer/__generated__/UserMainQueryRendererQuery.graphql";
import {yupResolver} from "@hookform/resolvers/yup";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";
import UserTokenForm from "@/Domains/AuthenticationManagement/Usertoken/Forms/UserTokenForm";
import CreateOrUpdateUserTokenMutation from "@/Domains/AuthenticationManagement/Usertoken/Mutations/CreateOrUpdateUserTokenMutation";
import * as yup from "yup";
import { checkPasswordStrength } from "@/Utils/Common";

interface IManagerBookingSearchMainView {
    viewData: UserMainQueryRendererQueryResponse;
    relay: RelayRefetchProp;
    token: any;
}

const UserTokenView: FunctionComponent<IManagerBookingSearchMainView> = ({
                                                                        viewData,
    token,
                                                                    }) => {
    const {t} = useTranslation();
    const [isLoading] = useState(false);
    const {displayMessage} = useDisplayMessage();
    const confirm = useConfirm();



    const defaultValues = {
        userId:  "", // str,
        username: "", // str, required
        firstname:  "", // str, required,
        lastname:  "", // str, required,
        email:  "", // str,
        language:  "", // str,
        password:  "",
        passwordConfirm: ""

    };

    const schema = yup
        .object({
            password: yup.string().required(t("general.thisFieldMustBeFilled"))
            .test(
                "password-strength",
                t("userToken.passwordStrength.passwordNotSecureEnoughText"),
                (value) => checkPasswordStrength(value || "").score >= 3
            ),
            passwordConfirm: yup.string().test(
                "not-null",
                t("general.passwordNotMatch"),
                (value) => {
                    // @ts-ignore
                    if (
                        value != methods.getValues("password")
                    ) {
                        return false;
                    }

                    return true;
                }
            ).required(t("general.thisFieldMustBeFilled")),
            email: yup.string().required(t("general.thisFieldMustBeFilled"))
                    .email(t("userToken.validEmailText")),
            firstname: yup.string().required(t("general.thisFieldMustBeFilled")),
            lastname: yup.string().required(t("general.thisFieldMustBeFilled")),
            language: yup.string().required(t("general.thisFieldMustBeFilled")),
        }).required()


    const methods = useForm({
        mode: "onSubmit",
        defaultValues,
        // @ts-ignore
        resolver: yupResolver(schema),
    });


    //@ts-ignore
    const saveUser = (data, callback, resolve) => {

        // @ts-ignore
        const input: CreateOrUpdateUserTokenInput = {
            username: data.email,
            crentPassword: data.password,
            defaultLanguage: data.language,
            token: token,
            firstname: data.firstname,
            lastname: data.lastname,
            email: data.email
        };
        CreateOrUpdateUserTokenMutation(input, (err, result) => {
            displayMessage("success", (t("messages.user_save_success")));
            callback();
        });
    };

    //@ts-ignore
    const onSubmit = (
        data,
        shouldWarnBeforeClose: boolean,
        callback: () => void,
        isDirty: boolean
    ) => {
        const passwordCheck = checkPasswordStrength(data.password);

        if (!passwordCheck.isValid) {
            return;
        }
        return new Promise((resolve, reject) => {
            if (!isDirty) {
                resolve(true);
                return;
            }
            if (shouldWarnBeforeClose) {
                confirm({
                    allowClose: true,
                    cancellationText: t("general.close"),
                    confirmationText: t("general.saveAndClose"),
                    content: (
                        <WarningConfirmDialog
                            headline={t("general.headline.unsavedChanges")}
                            textContent={t(
                                "general.messages.unsavedChangesWillBeLost"
                            )}
                        />
                    ),
                })
                    .then(() => {
                        saveUser(
                            data,
                            () => {
                                callback();
                                resolve(true);
                            },
                            resolve
                        );

                        return;
                    })
                    .catch(() => {
                        callback();
                        resolve("not accept warning");
                        return;
                    });
            } else {
                saveUser(
                    data,
                    () => {
                        callback();
                        resolve(true);
                    },
                    resolve
                );
                return;
            }
        });
    };


    const renderContent = () => {
        if (isLoading) {
            return <LoadingElement/>;
        }

        return (
            <UserTokenForm
                viewData={viewData}
                token={token}
                onSubmit={onSubmit}
            />
        );
    };

    return (
        <FormProvider {...methods}>
            <ViewWithSearchHeaderContainer
                contentComponent={renderContent()}
                isOpenAsDialog={false}
            />
        </FormProvider>
    );
};

export default UserTokenView;
